
<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>렘넌트 리스트</strong>
          </div>
          <b-row align-h="end">
            <b-col
              md="5"
              class="text-right"
            >
              <b-btn
                class="mb-1"
                variant="primary"
                size="sm"
                :disabled="noAuth"
                @click="getRemnantList()"
              >
                새로고침
              </b-btn>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col
              md="4"
            >
              <b-form-group
                label="Per page"
                label-cols-sm="6"
                label-cols-md="4"
                label-cols-lg="3"
                label-align-sm="right"
                label-size="sm"
                label-for="perPageSelect"
                class="mb-0"
              >
                <b-form-select
                  id="perPageSelect"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                />
              </b-form-group>
            </b-col>
            <b-col md="5">
              <b-input-group size="sm">
                <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Type to Search"
                />
                <b-input-group-append>
                  <b-button
                    :disabled="!filter"
                    @click="filter = ''"
                  >
                    Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="3">
              <h4>
                <b-badge
                  variant="dark"
                >
                  <strong>Total: {{ totalRows }}</strong>
                </b-badge>
              </h4>
            </b-col>
          </b-row>
          <b-row
            align-h="center"
            class="text-center"
          >
            <b-table
              class="mb-0 table-outline"
              head-variant="light"
              hover
              :items="itemAll"
              :fields="fieldsAll"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
            >
              <template
                v-slot:cell(auth)="data"
              >
                <div>
                  <h5>
                    <b-badge :variant="data.value === '렘넌트' ? 'info' : (data.value === '수퍼' ? 'success' : 'warning')">
                      {{ data.value }}
                    </b-badge>
                  </h5>
                </div>
              </template>
              <template
                v-slot:cell(name)="data"
              >
                <b-button
                  variant="outline-success"
                  size="md"
                  @click="showRowDetail(data.item.email, data.item._showDetails)"
                >
                  <b>{{ data.value + '  ' }}</b>
                  <b-badge
                    v-if="data.item.kid !== '아님'"
                    variant="primary"
                  >
                    {{ data.item.kid }}
                  </b-badge>
                </b-button>
              </template>
              <template
                v-slot:cell(age)="data"
              >
                <div>
                  {{ data.value }}
                </div>
              </template>
              <template
                v-slot:cell(longterm)="data"
              >
                <div>
                  {{ data.value }}
                </div>
              </template>
              <template
                v-slot:row-details="row"
              >
                <b-card>
                  <remnant-admin
                    ref="remnantAdmin"
                    :email="row.item.email"
                    @adminUpdated="getRemnantList()"
                  />
                  <remnant-past-apply
                    ref="remnantPastApply"
                    :email="row.item.email"
                  />
                  <remnant-past-review
                    ref="remnantPastReview"
                    :email="row.item.email"
                    :no-review="false"
                  />
                  <remnant-past-omc
                    ref="remnantPastOmc"
                    :email="row.item.email"
                  />
                  <b-row class="mb-2">
                    <b-col md="12">
                      <b-form-input
                        v-model="row.item.email"
                        :readonly="true"
                      />
                    </b-col>
                  </b-row>
                  <remnant-basic
                    ref="remnantBasic"
                    :email="row.item.email"
                    :read-only="true"
                  />
                  <remnant-family
                    ref="remnantFamily"
                    :email="row.item.email"
                    :read-only="true"
                  />
                  <remnant-training
                    ref="remnantTraining"
                    :email="row.item.email"
                    :read-only="true"
                  />
                </b-card>
              </template>
            </b-table>
          </b-row>
          <b-row
            align-h="center"
            class="my-1"
          >
            <b-col
              cols="5"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '../api'
import RemnantBasic from './remnant/RemnantBasic'
import RemnantFamily from './remnant/RemnantFamily'
import RemnantTraining from './remnant/RemnantTraining'
import RemnantPastReview from './remnant/RemnantPastReview'
import RemnantPastOmc from './remnant/RemnantPastOmc'
import RemnantPastApply from './remnant/RemnantPastApply'
import RemnantAdmin from './remnant/RemnantAdmin'

export default {
  name: 'RemnantList',
  components: { RemnantBasic, RemnantFamily, RemnantTraining, RemnantPastReview, RemnantPastOmc, RemnantAdmin, RemnantPastApply },
  data: function () {
    return {
      filter: null,
      filterOn: ['auth', 'name', 'age'],
      totalRows: 0,
      currentPage: 1,
      perPage: 100,
      pageOptions: [10, 15, 20, 50, 100],
      itemAll: [],
      noAuth: false,
      fieldsAll: [
        {
          key: 'auth',
          label: '권한',
          sortable: true,
          formatter: (value, key, item) => {
            return this.$store.getters.authNameVal(value)
          },
          sortByFormatted: true,
          filterByFormatted: true
        },
        {
          key: 'name',
          label: '이름',
          sortable: true
        },
        {
          key: 'age',
          label: '나이',
          sortable: true
        },
        {
          key: 'longterm',
          label: '장기장학생',
          sortable: true
        }
      ]
    }
  },
  mounted () {
    if (this.$store.getters.isSuper) {
      this.getRemnantList()
    } else {
      this.noAuth = true
      this.$router.push('/dashboard')
    }
  },
  methods: {
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    showRowDetail (email, val) {
      this.itemAll.forEach(row => {
        if (row.email === email) {
          row._showDetails = !val
        } else {
          row._showDetails = false
        }
      })
    },
    getAge (birthday) {
      let birth = new Date(birthday)
      let today = new Date()
      var todayYear = today.getFullYear()
      return todayYear - birth.getFullYear() + 1
    },
    parseRemnant (data) {
      this.itemAll = []
      data.forEach(elem => {
        var item = {}
        item['auth'] = elem.auth
        item['name'] = elem.name
        item['age'] = this.getAge(elem.birth)
        item['longterm'] = elem.longterm === 0 ? '아님' : elem.longterm === 1 ? '장학부 추천(A)' : elem.longterm === 2 ? '부서 추천(A)' : '지정 기탁(B)'
        item['kid'] = elem.kid
        item['email'] = elem.email
        item['_showDetails'] = false
        this.itemAll.push(item)
      })
      this.totalRows = this.itemAll.length
    },
    getRemnantList () {
      if (this.$store.getters.isSuper) {
        api.request('get', '/admin/remnant/list')
          .then(response => {
            var data = response.data
            this.parseRemnant(data.docs)
          })
          .catch(error => {
            alert(error)
          })
      } else {
        // 오면 안되지만 방어코드
        this.noAuth = true
      }
    }
  }
}
</script>

<style>
</style>
